import type { ReactNode } from 'react';
import clsx from 'clsx';
import InfoIcon from 'components/icons/info';

import style from './info-box.module.scss';

// Custom CustomMessage type
export type CustomMessage = {
  headerText?: ReactNode,
  bodyText: ReactNode,
  hasInfoStyle?: boolean,
};

type Props = {
  headerText?: ReactNode,
  bodyText: ReactNode,
  hasErrorStyle?: boolean;
  hasWarningStyle?: boolean;
  hideIcon?: boolean;
}

const InfoBox = ({
  headerText,
  bodyText,
  hasErrorStyle = false,
  hasWarningStyle = false,
  hideIcon = false,
}: Props) => {
  if (!headerText && !bodyText) {
    return null;
  }

  const boxClasses = clsx(style.Info, {
    [style.Error]: hasErrorStyle,
    [style.Warning]: hasWarningStyle,
  });

  return (
    <div className={boxClasses}>
      {!hideIcon && <div className={style.IconContainer}><InfoIcon /></div>}
      <div className={style.Content}>
        {headerText && (
          <div className={style.Header}>
            {headerText}
          </div>
        )}
        {bodyText && (
          <div>
            {bodyText}
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoBox;
